import { Alert } from 'tailwindcss-stimulus-components'
import { stimulus } from '~/init'

stimulus.register('flash', Alert)
